var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1235_12498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 3.15918C10.8398 3.15918 6.6665 7.33251 6.6665 12.4925C6.6665 14.8125 7.33317 16.9858 8.5465 18.9458C9.81317 20.9992 11.4798 22.7592 12.7598 24.8125C13.3865 25.8125 13.8398 26.7458 14.3198 27.8258C14.6665 28.5592 14.9465 29.8258 15.9998 29.8258C17.0532 29.8258 17.3332 28.5592 17.6665 27.8258C18.1598 26.7458 18.5998 25.8125 19.2265 24.8125C20.5065 22.7725 22.1732 21.0125 23.4398 18.9458C24.6665 16.9858 25.3332 14.8125 25.3332 12.4925C25.3332 7.33251 21.1598 3.15918 15.9998 3.15918ZM15.9998 16.1592C14.1598 16.1592 12.6665 14.6658 12.6665 12.8258C12.6665 10.9858 14.1598 9.49251 15.9998 9.49251C17.8398 9.49251 19.3332 10.9858 19.3332 12.8258C19.3332 14.6658 17.8398 16.1592 15.9998 16.1592Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1235_12498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.492676)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.1cbf10eb6b0f8512bbf18903775e0338.svg";
export { ForwardRef as ReactComponent };